import Modal from "common/Modal/Modal";
import { SuccessConfetti } from "common/Icons/Icons";
import styled from "styled-components";
import Text from "common/Typography/Text";
import { typography } from "@shared/common/Themes/typography";
import Button from "common/Buttons/Button";
import { useUser } from "@shared/utils/hooks/misc";
import { getTelegramWebAppPath } from "utils/routes";
import { PORTFOLIO_ACCOUNTS_PATH } from "common/constants";

interface TgQuickConnectSuccessModalProps {
  isOpen: boolean;
  closeModal: () => void;
}

const TgQuickConnectSuccessModal = ({
  isOpen,
  closeModal,
}: TgQuickConnectSuccessModalProps) => {
  const { user } = useUser();

  const onBackToTelegramClick = () => {
    if (user?.bot_url) {
      window.open(
        getTelegramWebAppPath(user?.bot_url, PORTFOLIO_ACCOUNTS_PATH),
        "_blank"
      );
    }
  };

  return (
    <Modal open={isOpen} onCancel={closeModal} footer={false}>
      <Wrapper>
        <SuccessConfetti
          style={{ width: 100, height: "auto", marginBottom: 16 }}
        />
        <Text
          $weight={typography.fontWeights.MEDIUM}
          $size="L"
          style={{ marginBottom: 4 }}
        >
          Accounts Created Successfully
        </Text>
        <Text type="secondary" style={{ marginBottom: 16 }}>
          Your exchange account has been connected successfully. Click the
          button below to navigate back to Cornix's Telegram app. Alternatively,
          close the modal to continue using Cornix in the browser.
        </Text>
        <Button type="link" onClick={onBackToTelegramClick}>
          Back to Telegram App
        </Button>
      </Wrapper>
    </Modal>
  );
};

export default TgQuickConnectSuccessModal;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;
